import { Button, Modal } from '@mairistem/composants';
import _ from 'lodash';
import React from 'react';
import HTML_MAIL_RELANCE_DEFAUT from '@/assets/text/htmlMailRelanceDefaut';
import { EditeurMail } from '@/components/EditeurMail';
import { RELANCE_MAIL_ELEMENTS_DISPONIBLES } from '@/constants';
import type { ElementDisponibleType } from '@/types';

type ModalMailRelanceProps = {
  htmlMailRelance?: string;
  loading?: boolean;
  /** Éléments insérables affichés dans la barre latérale. Défaut : relance après-échéance (impayés). */
  elements?: ElementDisponibleType[];
  /** Contenu HTML par défaut (bouton « rétablir » + valeur initiale si htmlMailRelance vide). */
  htmlDefaut?: string;
  onClose: () => void;
  onSave?: (html: string) => void;
};

const ModalMailRelance = (props: ModalMailRelanceProps) => {
  const {
    htmlMailRelance,
    loading = false,
    elements = RELANCE_MAIL_ELEMENTS_DISPONIBLES,
    htmlDefaut = HTML_MAIL_RELANCE_DEFAUT,
    onClose,
    onSave,
  } = props;

  const initialHtml = _.isEmpty(htmlMailRelance) ? htmlDefaut : htmlMailRelance;

  const [html, setHtml] = React.useState<string>(initialHtml);
  const [modifie, setModifie] = React.useState<boolean>(false);

  const handleEditeurChange = React.useCallback((value: string, isModifie: boolean) => {
    setHtml(value);
    setModifie(isModifie);
  }, []);

  const handleEnregistrer = React.useCallback(() => {
    onSave?.(html);
  }, [html, onSave]);

  return (
    <Modal open size="large" onClose={onClose} closeIcon={!loading}>
      <Modal.Header>Personnalisation du mail de relance</Modal.Header>
      <Modal.Content scrolling={false}>
        <EditeurMail
          htmlDefaut={htmlDefaut}
          htmlInitial={initialHtml}
          elements={elements}
          loading={loading}
          onChange={handleEditeurChange}
        />
      </Modal.Content>
      <Modal.Actions>
        <Button
          data-testid="button-annuler"
          onClick={onClose}
          basic
          size="tiny"
          icon="close"
          content="Annuler"
          disabled={loading}
        />
        <Button
          data-testid="button-enregistrer"
          positive
          onClick={handleEnregistrer}
          content="Enregistrer"
          icon="save"
          disabled={!modifie || loading}
          loading={loading}
        />
      </Modal.Actions>
    </Modal>
  );
};

export default ModalMailRelance;
